var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-1 mt-1 bg-color-black",attrs:{"id":"center"}},[_c('el-tag',{staticClass:"coreTitle mt-1 pb-1"},[_vm._v("2024年公司业务情况")]),_c('div',{staticClass:"up"},[_c('div',{ref:"chartContainer",staticStyle:{"height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }